import JavaScriptQuestions from './javascript.js';
import DartQuestions from './dart.js';
import PHPQuestions from './php.js';
import HTMLQuestions from './html.js';
import PythonQuestions from './py.js';

const Tests = {
    'JavaScript': JavaScriptQuestions,
    'DART 3': DartQuestions,
    'PHP 8': PHPQuestions,
    'HTML': HTMLQuestions,
    'Py 3': PythonQuestions
};

export default Tests;
